import _ from 'lodash';
import Assignee from 'models/assignee';
import Conversation from 'models/conversation';
import SwitchCurrentConversation from 'actions/customer/switch_current_conversation';
import UpdateCurrentComposition from 'actions/composition/update_current_composition';
import ConvDtoConverter from 'scripts/application/dto_converters/conversation_converter';

export default class CreateConversation {
  constructor(context) {
    this.context = context;
  }

  get currentCustomerId() {
    return this.context.stores.currentLocation.get().customerId;
  }

  get currentAgentId() {
    return this.context.stores.currentAgent.get().id;
  }

  // Returns the first (alphabetically by name) of the agent's routing groups or
  // all groups, if the agent does not belong to any
  _getDefaultGroupId() {
    let allGroups = this.context.stores.routingGroups.findAll();
    let orderedGroups = _.orderBy(allGroups, ['name'], ['asc']);

    let defaultGroup = this.context.stores.currentAgent.get().getDefaultRoutingGroup(orderedGroups);
    return defaultGroup && defaultGroup.id;
  }

  run() {
    let conversationStore = this.context.stores.customers.storesFor(this.currentCustomerId).conversations;

    let agentId = this.currentAgentId;
    let routingGroupId = this._getDefaultGroupId();

    let conversation = Conversation.create({
      assignee: new Assignee({ routingGroupId, agentId }),
      status: Conversation.Status.OPEN,
      conversationItems: [],
    });

    conversationStore.setPendingNew(conversation);
    this.context.gateways.customerHistory.addConversation(this.currentCustomerId, ConvDtoConverter.toDto(conversation));

    let conversationId = conversation.id;
    this.context.executeAction(SwitchCurrentConversation, { conversationId });
    this.context.executeAction(UpdateCurrentComposition, conversationId);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation/create_conversation.js